import { Component, Input, OnInit } from '@angular/core';
import { ModuleManager } from 'src/shared/models/module-manager';
import { ModuleManagerRefreshType } from 'src/shared/models/module-manager/module-manager-options.model';
import { Module } from 'webpack';

@Component({
    selector: 'cv-notepad',
    templateUrl: './notepad.component.html',
    styleUrls: ['./notepad.component.scss']
})
export class NotepadComponent implements OnInit {

    @Input() moduleManager: ModuleManager;
    @Input() moduleKey: string;

    text: string = null;

    constructor() { }

    ngOnInit(): void {
        this.moduleManager.setOptions({
            enableWidthClass: false,
            widgetMode: false,
            onSettingsApplied: (settings) => {},
            refreshType: ModuleManagerRefreshType.Auto,
            onRefresh: () => {},
            getTransferObject: () => ({data: this.text}),
            onTransferLoaded: (transferData) => this.text = transferData.data,
        });
    }

}
